import groupsMap from '@/scripts/stage/groupsMap';
import content from '@/assets/data/content.json';

export const getGroup = { // eslint-disable-line
  byPage(page) {
    const indexModel = content.findIndex(el => el.idPage === page);

    if (indexModel === -1) console.log('model not found');
    return groupsMap.get(content[indexModel].idModel);
  },
  byIndex(index) {
    const indexModel = content.findIndex(el => el.index === index);

    if (indexModel === -1) console.log('model not found');
    return groupsMap.get(content[indexModel].idModel);
  },
};
